import { makeStyles } from '@mui/styles';
import { Box } from '@mui/system';
import React from 'react';

const useStyles = makeStyles({
  root: {},
  container: {
    maxWidth: '1096px',
    display: 'flex',
    flexWrap: 'wrap',

    '@media only screen and (max-width: 1150px)': {
      justifyContent: 'space-around',
    },

    '@media only screen and (max-width: 768px)': {
      justifyContent: 'center',
      marginTop: '12px',
    },
  },

  contents: {
    display: 'flex',
    marginBottom: '22px',

    '@media only screen and (max-width: 768px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },

  item: {
    marginRight: '66px',
    margin: 0,
    width: '482px',
    paddign: 0,

    '@media only screen and (max-width: 1150px)': {
      width: '440px',
      marginRight: '44px',
    },

    '@media only screen and (max-width: 590px)': {
      marginRight: 0,
      width: '320px',
    },

    '@media only screen and (max-width: 329px)': {
      marginRight: 0,
      width: '300px',
    },
  },
  imageBox: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    marginRight: '26px',
    '@media only screen and (max-width: 768px)': {
      marginRight: 0,
    },
  },
  imgB: {
    width: '154px',
    height: '154px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: 'solid 1px #5a5a5a',
    overflow: 'hidden',
    boxSizing: 'border-box',
  },
  contentImage: {
    // marginRight: '24px',

    '@media only screen and (max-width: 768px)': {
      marginRight: 0,
    },
  },

  imageAlt: {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '66px',
    height: '21px',
    padding: '3px 0',
    backgroundColor: '#5a5a5a',
    color: '#f4f4f4',
    fontSize: '12px',
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    '@media only screen and (max-width: 768px)': {
      width: '66px',
      height: '21px',
    },
  },
  textBox: {
    width: '302px',
    position: 'relative',
    '@media only screen and (max-width: 768px)': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
  },
  title: {
    fontSize: '36px',
    fontWeight: 600,

    '@media only screen and (max-width: 1150px)': {
      fontSize: '30px',
      // height: '68px',
    },

    '@media only screen and (max-width: 768px)': {
      textAlign: 'center',
      fontSize: '30px',
    },
  },
  subText: {
    fontSize: '16px',
    lineHeight: 1.25,
    position: 'absolute',
    bottom: '23px',
    '@media only screen and (max-width: 1150px)': {
      fontSize: '14px',
      marginTop: '16px',
    },

    '@media only screen and (max-width: 768px)': {
      fontSize: '16px',
      // height: '52px',
      position: 'initial',
    },
  },
  dividerBox: {
    display: 'flex',
    marginBottom: '15px',
  },
  firstDivider: {
    width: '100%',
    height: '4px',
    marginTop: '22px',
    backgroundColor: '#191919',
    marginRight: '24px',

    '@media only screen and (max-width: 1150px)': {
      marginTop: '12px',
    },
  },

  secondDivider: {
    width: '302px',
    height: '2px',
    marginTop: '27px',
    backgroundColor: '#191919',
    position: 'absolute',
    bottom: '0',
    '@media only screen and (max-width: 1150px)': {
      width: '280px',
      marginTop: '27px',
    },
    '@media only screen and (max-width: 768px)': {
      position: 'initial',
    },
    '@media only screen and (max-width: 590px)': {
      width: '302px',
      marginBottom: '16px',
    },
  },
});

export default function MouCardMolecules(props) {
  const classes = useStyles();
  const { contentsList } = props;
  return (
    <Box className={classes.root}>
      <Box className={classes.container}>
        {contentsList.map((con, i) => {
          return (
            <Box className={classes.item} key={i}>
              <Box className={classes.contents}>
                <Box className={classes.imageBox}>
                  <Box className={classes.imageAlt}>{con.badge}</Box>
                  <Box className={classes.imgB}>
                    <img className={classes.contentImage} alt={`mou ${i}`} src={con.img} />
                  </Box>
                  <Box className={classes.firstDivider}></Box>
                </Box>
                <Box className={classes.textBox}>
                  <Box className={classes.title}>{con.title}</Box>
                  <Box className={classes.subText}>{con.subText}</Box>
                  <Box className={classes.secondDivider}></Box>
                </Box>
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}
